import MarkdownPage from "@/lib/components/MarkdownPage";

const markdownData = `
# Personvernsvilkår

Eventlista samler kun den aller nødvendigste informasjon om deg når du bruker nettsiden. All data lagres i Norge og vi bruker kun norske underleverandører.

## Vi samler inn følgende data
* Dato og tidspunkt for siste innlogging, og når du brukte nettsiden sist.
* Alt du selv legger til, som eventer, diskusjonstråder, bilder, e-postadresse, bio og instillinger.
* Din IP-adresse logges sammen med og hvilke undersider du besøker. Disse loggene slettes fortløpende og brukes kun for å løse feilsituasjoner.

## Vi bruker dataen til følgende formål
* Tilby grunnleggende funksjonalitet.
* Generere besøksstatistikk for å forbedre tjenesten.
* Gi deg relevant eller viktig informasjon.

## Vi vil aldri
* Samle inn data om deg utenfor Eventlista.
* Samle inn data som er irrelevant for å tilby tjenesten.
* Selge dine data til tredjepart.

*Sist oppdatert: 26. juli 2024*
`

export default function Index() {
    return (
        <MarkdownPage markdown={markdownData}/>
    )
}